const translateAssine = {
  portugues: {
    title: 'Assine Agora!',
    subTitle: 'E tenha um clube de vantagens!',
    header: 'Ainda não é sócio?',
    subBenefits:
      'Aproveite para desfrutar do melhor Clube de internet e tenha um mundo de vantagens.',
    listBenefits: [
      'HD photos',
      'Vídeos em 4K* (Ultra HD)',
      'Assista transmissões ao vivo dos ensaios sem censura',
      'Acesso à todas as Lives gravadas em 4K *(ULTRA HD) ',
      'Seção exclusiva só com pezinhos',
      'Ensaios Completos com fotos exclusivas',
      'Mais de 40.000 fotos e centenas de vídeos',
      'Bella Cloud: salve seus vídeos e fotos favoritas com total privacidade',
      'ASSINATURA SIGILOSA (o nome do Bella não aparece na fatura do seu cartão de crédito, nem em sua conta bancária).'
    ],
    listBenefitsMobile: [
      'HD photos',
      'Vídeos em 4K* (Ultra HD)',
      'Transmissões ao vivo dos ensaios sem censura',
      'Acesso às Lives gravadas em 4K *(ULTRA HD) ',
      'Seção exclusiva só com pezinhos',
      /*'Ensaios Completos com fotos exclusivas',*/
      'Mais de 40.000 fotos e centenas de vídeos',
      'Bella Cloud: salve seus vídeos e fotos favoritas'
      /*'ASSINATURA SIGILOSA(o nome do Bella não aparece na fatura do seu cartão de crédito, nem em sua conta bancária).'*/
    ],
    footerBenefits: '* Todas cobranças aparecem como BDS',
    buttonSubscribe: 'Assine agora',
    buttonCredits: 'Compre Créditos',
    buttonCredits2: 'Compre Agora',
    buttonSubscribe2: 'Assine',
    buttonSubscribe3: 'Assine Já!',    
    holderSocio: 'Já é sócio?',
    holderLogin: 'Faça seu login',
    titleFormUser: 'Informe seus dados:',
    formUser: {
      firstName: 'Nome',
      lastName: 'Sobrenome',
      email: 'E-mail',
      emailAgain: 'Confirme seu e-mail',
      anotherEmail: 'E-mail alternativo (opcional)',
      country: 'País',
      password: 'Senha',
      passwordAgain: 'Redigite sua senha'
    },
    legendaAssinePagamentosTitle:
      '*Válido apenas para cartão de crédito. Para obter o parcelamento é necessário que você selecione quantas parcelas deseja (1x, 2x ou 3x), logo abaixo do pedido do código de segurança do cartão',
    legendaAssinePagamentosSubTitle:
      'Para sua conveniência, sua assinatura será automaticamente renovada por períodos equivalentes. Para cancelar, solicite pelo menu Contato.',
    PlansSubTitle: 'Escolha a sua forma de pagamento:',
    AlterPlansSubTitle: 'Escolha a sua forma de pagamento:',
    AlterPaymentSubTitle: 'Forma de pagamento',
    nameHolderCreditCards: 'Nome do portador',
    cpfCreditCards: 'CPF do portador',
    numberCreditCards: 'Número do cartão',
    validCreditCards: 'Validade mês/ano',
    parcelas: 'Número de Parcelas',
    cvvCreditCards: 'Código de segurança',
    PlanValueDay: 'apenas',
    day: 'dia',
    current: 'R$',
    legendFormCreditCard:
      'Pague com cartão de crédito, é rápido e totalmente seguro.<br> Seu acesso é liberado imediatamente após o pagamento. <br>Para maior discrição, o débito aparecerá na fatura do seu cartão de crédito como BDS.',
    legendFormTransfer:
      'Se você tem conta no Itaú pague através do ITAU Shopline, é simples e totalmente seguro.<br>Pagando com Transferência Eletrônica o correntista<br>Itaú tem seu acesso é liberado em poucos minutos após o pagamento.<br>Ao clicar em "CONCLUIR COMPRA", desbloqueie os POP-UPS do navegador para abrir a página do Itaú Shopline.',
    legendFormPix:
      'Clique em Gerar QRCode e aponte a câmera do seu celular com seu aplicativo bancário para pagar via Pix ou copie o código gerado abaixo da imagem e cole no seu aplicativo bancário do Pix para efetuar o pagamento.<br><br><strong>ATENÇÃO: o código e QRCode são válidos apenas por 1 hora.</strong>',
    legendFormBoleto:
      'Escolhendo esta opção, será aberta em nova janela o boleto bancário.<br>Imprima e pague o boleto em qualquer agência bancária até a data do vencimento.<br>Será cobrado o valor do plano de assinatura escolhido acrescido<br>do custo do boleto, no valor de R$ 3,00.<br><br>Seu acesso somente será liberado após a compensação do pagamento,que ocorrem em até<br><strong>3 dias úteis após o pagamento.</strong>',
    titleTermsUse: 'Termos e Condições',
    aceitlabel: 'Li e aceito os termos e condições.',
    buttonLabelFinish: 'Finalizar assinatura',
    legendaMyAcoountPagamentosSubTitle1: `*Válido apenas para cartão de crédito. Para obter o parcelamento é necessário que você selecione quantas parcelas deseja (1x, 2x ou 3x), logo abaixo do pedido do código de segurança do cartão.`,
    legendaMyAcoountPagamentosSubTitle2: `Para sua conveniência, sua assinatura será automaticamente renovada por períodos equivalentes. Para cancelar, solicite pelo menu Contato.`,
    AlterPlansDescription1: 'Seu plano atual de assinatura atual é:',
    AlterPlansDescription2:
      'Se você deseja alterar o plano basta selecionar uma das opções abaixo.',
    AlterPaymentDescription1: 'Seu formato de pagamento atual é:',
    AlterPaymentDescription2:
      'Se você deseja alterar o seu formato de pagamento, basta selecionar uma das opções abaixo.',
    PromotionSpecial: 'Promoção Especial',
    labelDiscont: ' DE DESCONTO',
    credits: {
      subBenefits:
        'Garanta logo abaixo seus créditos para download e compre os vídeos exclusivamente para você.',
      listBenefits: [
        'Assinantes do Bella ganham o <strong>TRIPLO de Créditos;</strong>',
        'Não há necessidade de assinatura ativa, proporcionando liberdade total de escolha;',
        'Desfrute de conteúdo exclusivo e assista às suas modelos favoritas em 4K;',
        'Salve os vídeos para assistir a qualquer momento, em qualquer lugar;',
        'Praticidade: assista em qualquer lugar, sem a necessidade de conexão à internet.'
      ],
      title: 'Compre Créditos para Download',
      subTitle: 'E adquira vídeos exclusivos em 4K das suas modelos favoritas',
      footerBenefits: '* Cada download de 1 vídeo da modelo corresponde a 1 crédito',
      footerBenefits2: '* Cada download de 1 vídeo de live corresponde a 2 crédito',
      PlansSubTitle: 'Conheça os pacotes de downloads:',
      PlansAssi: 'Assinante',
      PlansNoAssi: 'Não Assinante',
      PlansTitle: 'Escolha a quantidade de créditos:',
      recive: 'recebe',
      price: 'Valor',
      option: 'Selecione a opção desejada:',
      subscribeInfo: 'Para completar a compra como assinante é preciso ter uma conta ativa de assinante do Bella da Semana. Você será direcionado para a página de login antes do pagamento.'
    },
    PlanPrevTitle: 'Conheça nossos planos:',
    double: 'RECEBA EM DOBRO',
    assineOptions1: 'Plano de Assinatura',
    assineOptions2: 'Créditos para Downloads',
    perMonth: '/ mês',
    totalValue: 'À vista',
    textCredits1: '+ Ganhe',
    textCredits2: 'Créditos GRÁTIS',
    moreDetails: 'Mais Detalhes',
    breadcrumb1: 'Planos',
    breadcrumb2: 'Dados Cadastrais',
    breadcrumb3: 'Detalhes do Pagamento',
    breadcrumb4: 'Confirmação',
    breadcrumbMobile2: 'Registro',
    breadcrumbMobile3: 'Pagamento',
    buttomPay: 'Ir para o pagamento',
    loginGoogle: 'Login com Google',
    loginFacebook: 'Fazer login com o Facebook',
    loginText: 'Ou escolha a opção:',
    loginText1: 'Ou fazer login com:',    
    resumeTitle: 'Resumo do Pedido',
    titleForm: 'Dados para Cadastro',
    titleFormCheckout: 'Pagamento',
    footerOptionsCheckout: 'Todas as transações são seguras e encriptadas',
    checkPlanAndLogin: 'Para prosseguir, faça login e escolha um plano de assinatura ou créditos.',
    checkPlan: 'Para prosseguir, escolha um plano de assinatura ou créditos.'
  },
  ingles: {
    title: 'Subscribe Now!',
    subTitle: 'And have a benefits club!',
    header: 'Not a member yet?',    
    subBenefits: 'Take advantage of the best Internet Club and have a world of benefits',
    listBenefits: [
      'HD photos',
      '4K* (Ultra HD) videos',
      'Watch live streams of uncensored rehearsals',
      'Access to all 4K *(ULTRA HD) recorded Lives',
      'Exclusive section only with delicate feet',
      'Full photoshoots with exclusive pictures',
      'Over 40,000 photos and hundreds of videos',
      'Bella Cloud: save your favorite videos and photos in complete privacy',
      "CONFIDENTIAL SUBSCRIPTION (Bella's name does not appear on his credit card statement or in his bank account)"
    ],
    legendFormPix: '',
    listBenefitsMobile: [
      'HD photos',
      '4K* (Ultra HD) videos',
      'Watch live streams of uncensored rehearsals',
      'Access to all 4K *(ULTRA HD) recorded Lives',
      'Exclusive section only with delicate feet',
      /*'Full photoshoots with exclusive pictures',*/
      'Over 40,000 photos and hundreds of videos',
      'Bella Cloud: save your favorite videos and photos'
      /*"CONFIDENTIAL SUBSCRIPTION (Bella's name does not appear on his credit card statement or in his bank account)."*/
    ],
    footerBenefits: '* All charges appear as BDS',
    buttonSubscribe: 'Subscribe now',
    buttonSubscribe2: 'Subscribe',
    buttonSubscribe3: 'Subscribe now',    
    holderSocio: 'Are you already a member?',
    holderLogin: 'Log in',
    titleFormUser: 'Enter your details:',
    formUser: {
      firstName: 'Name',
      lastName: 'Last name',
      email: 'Email',
      emailAgain: 'Confirm your email',
      anotherEmail: 'Alternative email (optional)',
      country: 'Country',
      password: 'Password',
      passwordAgain: 'Retype your password'
    },
    captionSubscribePaymentsTitle:
      '*Valid for credit cards only. To obtain the installment payment, you must select how many installments you want (1x, 2x or 3x), just below the card security code request',
    captionSubscribePaymentsSubTitle:
      'For your convenience, your subscription will automatically renew for equivalent periods. To cancel, request via the Contact menu.',
    PlansSubTitle: 'Choose your payment method:',
    AlterPlansSubTitle: 'Choose your payment method:',
    AlterPaymentSubTitle: 'Payment method',
    nameHolderCreditCards: 'Holder name',
    cpfCreditCards: "holder's CPF",
    numberCreditCards: 'Card number',
    validCreditCards: 'Valid month/year',
    parcelas: 'Number of Installments',
    cvvCreditCards: 'Security code',
    PlanValueDay: 'only',
    day: 'day',
    current: '$',
    legendFormCreditCard:
      "Your access is granted immediately after payment.<br>For greater discretion, the charge will appear on<br>your credit card statement as BDS.<br><br>The amount will be charged in Reais, using the current exchange rate. This may result in a small variation of a few cents on your invoice.",
    titleTermsUse: 'Terms and Conditions',
    aceitlabel: 'I have read and accept the terms and conditions.',
    buttonLabelFinish: 'Finish signature',
    captionMyAcoountPaymentsSubTitle1: `*Valid for credit card only. To obtain the installment plan, you must select how many installments you want (1x, 2x or 3x), just below the card security code request.`,
    captionMyAcoountPaymentsSubTitle2: `For your convenience, your subscription will automatically renew for equivalent periods. To cancel, request through the Contact menu.`,
    AlterPlansDescription1: 'Your current subscription plan is:',
    AlterPlansDescription2:
      'If you want to change the plan, simply select one of the options below.',
    AlterPaymentDescription1: 'Your current payment format is:',
    AlterPaymentDescription2:
      'If you would like to change your payment format, simply select one of the options below.',
    PromotionSpecial: 'Promotion Special',
    labelDiscont: ' OFF',
    credits: {
      subBenefits:
        'Secure your download credits below and buy the videos exclusively for you to enjoy our models.',
      listBenefits: [
        'Bella Club subscribers <b>get TRIPLE the credits;</b>',
        'There is no need for an active subscription, providing complete freedom of choice;',
        'Enjoy exclusive content and watch your favorite models in 4K;',
        'Save videos to watch anytime, anywhere;',
        'Practicality: watch anywhere, without the slightest need for an internet connection.'
      ],
      title: 'Purchase credits for download!',
      subTitle: 'And get exclusive 4K videos and lives of your favorite models!',
      footerBenefits: '* Each download of 1 video corresponds to 1 credit',
      footerBenefits2: '* Each download of 1 live video corresponds to 2 credits',
      PlansSubTitle: 'know our download packages:',
      PlansAssi: 'Subscriber',
      PlansNoAssi: 'Non-Subscriber',
      PlansTitle: 'Choose the amount of credits:',
      recive: 'receives',
      price: 'Value',
      option: 'Select the desired option:',
      subscribeInfo: 'To complete your purchase as a subscriber, you must have an active BellaClub subscriber account. You will be redirected to the login page before payment.'      
    },
    buttonCredits: 'Buy Credits',
    buttonCredits2: 'Buy Now',    
    PlanPrevTitle: 'Know our plans:',
    double: 'GET DOUBLE',
    assineOptions1: 'Subscription Plan',
    assineOptions2: 'Credits for Downloads',
    perMonth: '/ month',
    totalValue: 'Total of',
    textCredits1: '+ Bonus',
    textCredits2: 'FREE credits',
    moreDetails: 'More Details',
    breadcrumb1: 'Plans',
    breadcrumb2: 'Registration Data',
    breadcrumb3: 'Payment Details',
    breadcrumb4: 'Confirmation',
    breadcrumbMobile2: 'Register',
    breadcrumbMobile3: 'Payment',
    buttomPay: 'Go to payment',
    loginGoogle: 'Log in with Google',
    loginFacebook: 'Log in with Facebook',
    loginText: 'Or choose the option:',
    loginText1: 'Or log in with:',    
    resumeTitle: 'Order Summary',
    titleForm: 'Registration Data',
    titleFormCheckout: 'Payment',
    footerOptionsCheckout: 'All transactions are secure and encrypted.',
    checkPlanAndLogin: 'To proceed, log in and choose a subscription plan or credits.',
    checkPlan: 'To proceed, choose a subscription plan or credits.'   ,
    legendFormBoleto: ''         
  }
}

export default translateAssine
